const isExternalImageSource = imageSource => imageSource.startsWith('http');

export default isExternalImageSource;
